<template>
<div>
    <p class="data-tip"><i class="iconfont">&#xe654;</i>本页面融资事件包含近1年的数据，榜单排名按照汇率换算后的实际融资额大小排列，但各融资事件金额以原币种显示。</p>
    <div class="financing_data">
        <!-- 最新Top30 融资额Top30 -->
        <div class="list_div">
            <Table :columns="columns" :data="list"></Table>
        </div>
        <Contanct :page="3">></Contanct>
        <Spin fix v-if="spinShow">
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
    </div>
</div>
</template>

<script>
import filter from 'js/filter'
import Contanct from '../Contanct'
import { eventTop } from '../../../../service'
export default {
  inject: ['login'],
  components: {
    Contanct
  },
  data() {
    return {
      spinShow: true,
      list: [],
      columns: [
        { title: '排名',width: 110, align: 'center', render: (h, params) => {
          if(params.row.rank_num < 4) {
            return h('img', { attrs: {src: require('../../../../assets/pic/top'+params.row.rank_num+'.png')}})
          }else{
            return h('span', params.row.rank_num)
          }
        }},
        { title: '公司名称',width: 200, render:(h, params) => {
          return h('div',{
              class: {company: true}
            },[
            h('div',
              {
                on: {click: () => {
                  if (this.$store.state.user_key) {
                    this.goEntityDetail(params.row.uid)
                  } else {
                    this.login()
                  }
                }},
                class: {logo_img: true}
              },[
                h('img', { attrs: {src: filter.logo_show(params.row.logo_path)}})
              ]),
            h('div',
              {class: {company_name: true}},[
                h('div',{class: {company_info: true}}, [
                  h('p', [
                    h('a',{
                      on: {click: () => {
                        if (this.$store.state.user_key) {
                          this.goEntityDetail(params.row.uid)
                        } else {
                          this.login()
                        }
                      }}
                    }, params.row.short_name)
                  ])
                  // h('p' ,filter.empty(params.row.ht_description,'暂无描述')),
                ])
              ])
          ])
        }},
        // { title: '行业领域',minWidth: 220, render:(h, params) => {
        //     if (params.row.tags != '') {
        //       return h('div', {class: {'dec-clamp': true}}, filter.dealString(params.row.tags, 'dynview_tag'))
        //     } else {
        //       return h('span', '--')
        //     }
        // }},
        {
          title: '简要介绍',
          minWidth: 220,
          render: (h, params) => {
            return h('div', {
              class: {
                'dec-clamp': true
              }
            }, filter.empty(params.row.description))
          }
        },
        { title: '融资轮次',width: 130, render:(h, params) => {
          if (params.row.type == '1') {
            return h('span', '被并购')
          } else {
            return h('span', filter.deal(params.row.round_id, 'round'))
          }
        }},
        { title: '融资额',width: 130, render:(h, params) => {
          return h('span', filter.amountJustRMBPrecise2(params.row.rmb ))
        }},
        // { title: '币种',width: 100, render: (h, params) => {
        //   return h('span', filter.deal(params.row.unit_id, 'unit'))
        // }},
        { title: '所在地',width: 170, render: (h, params) => {
          return h('span', filter.addressDeal(params.row.address_id, 3))
        }}
      ]
    }
  },
  methods: {
    async getList() {
      let res = await eventTop({}, (error) => { this.$Message.error('请求错误！') })
      if(res.status == 'success') {
        this.list = res.res
        this.spinShow = false
      } else {
        this.$Message.error(res.message)
      }
    },
    goEntityDetail(uid) {
      // this.$router.push({name:'CompanyDetail',params: {uid:uid}})
      const { href } = this.$router.resolve({
        name: "CompanyDetail",
        params: {
          uid: uid
        }
      })
      window.open(href, '_blank')
    }
  },
  created() {
    this.getList()
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/financing.stylus'
.financing_data .list_div
  padding-top: 0
  & >>> .ivu-table-wrapper
    .ivu-table
      tr
        td:first-of-type
        th:first-of-type
          .ivu-table-cell
            padding-right: 36px !important
</style>
